<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Purchase Entry Pass</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="entryPassSelect">Entry Pass Type</label>
      <select id="entryPassSelect" class="custom-select" name="entryPass"
              [(ngModel)]="entryPassId" required
              [disabled]="loadingEntryPasses" [class.disabled]="loadingEntryPasses">
        <option *ngIf="loadingEntryPasses">Loading...</option>
        <option *ngIf="!loadingEntryPasses" [value]="null">---</option>
        <option *ngFor="let entryPassType of entryPassList" [value]="entryPassType.id">
          {{ entryPassType.name }}
          <ng-container *ngIf="entryPassType.status === EntryPassStatus.retired">(Retired)</ng-container>
          <ng-container *ngIf="entryPassType.status === EntryPassStatus.draft">(Draft)</ng-container>
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="association">
      <label for="ownerSelect">Owner</label>
      <select id="ownerSelect" class="custom-select" name="customerId"
              [(ngModel)]="customerId" required
              [disabled]="loadingAssociationManagers" [class.disabled]="loadingAssociationManagers">
        <option *ngIf="loadingAssociationManagers">Loading...</option>
        <option *ngIf="!loadingAssociationManagers" [ngValue]="null">---</option>
        <option *ngFor="let associationManager of associationManagerList" [ngValue]="associationManager.customer_id">
          {{ associationManager.customer_first_name }} {{ associationManager.customer_last_name }}
        </option>
      </select>
      <small class="form-text">
        Select an association manager to act as the owner of the association's entry pass.
      </small>
      <div class="form-text text-danger">
        {{ errors.customerId }}
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <p class="mb-0 mt-4">
      <span *ngIf="customer">
        The button below will take you to the Climber App purchase page for the selected Entry Pass, logged in as {{ customer.first_name }} {{ customer.last_name }}.
      </span>
      <span *ngIf="!customer">
        The button below will take you to the Climber App purchase page for the selected Entry Pass.
      </span>
      From there you can complete the purchase.
    </p>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingEntryPasses || loadingSubmit)"
            [disabled]="(entryPassId === null) || (customerId === null)"
            [class.disabled]="(entryPassId === null) || (customerId === null)"
            (click)="handleSave()">
      Go to Climber App
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingEntryPasses || loadingAssociationManagers || loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
